const state = {
  product: {},
  addToBagOpen: false,
  compactStockNotifOpen: false,
  stockNotificationOpen: false,
  waitlistOpen: false,
};

const mutations = {
  setProduct(state, value) {
    state.product = value;
  },
  setAddToBagOpen(state, value) {
    state.addToBagOpen = value;
  },
  setShowCompactStockNotif(state, value) {
    state.compactStockNotifOpen = value;
  },
  setStockNotificationOpen(state, value) {
    state.stockNotificationOpen = value;
  },
  setWaitlistOpen(state, value) {
    state.waitlistOpen = value;
  },
  setSelectedVariant(state, value) {
    state.selectedVariant = value;
  },
};

const getters = {};

const actions = {
  setProduct({ commit }, product) {
    commit("setProduct", product);
  },
  openAddToBag({ commit, dispatch }, product) {
    dispatch("closeAddToBag");
    setTimeout(() => {
      commit("setProduct", product);
      commit("setAddToBagOpen", true);
    }, 100);
  },
  closeAddToBag({ commit }) {
    commit("setAddToBagOpen", false);
  },
  openStockNotification({ commit }, { product, variant }) {
    if (variant) {
      commit("setSelectedVariant", variant);
    } else {
      commit("setSelectedVariant", null);
    }
    commit("setProduct", product);
    commit("setStockNotificationOpen", true);
  },
  showCompactStockNotif({ commit }, { product, variant, show }) {
    commit("setProduct", product ?? null);
    commit("setSelectedVariant", variant ?? null);
    commit("setShowCompactStockNotif", show);
  },
  closeStockNotification({ commit }) {
    commit("setSelectedVariant", null);
    commit("setProduct", null);
    commit("setStockNotificationOpen", false);
  },
  openWaitlist({ commit }) {
    commit("setWaitlistOpen", true);
  },
  closeWaitlist({ commit }) {
    commit("setWaitlistOpen", false);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
